import { Schema } from "effect";

// Credential types - prevent mixing different secrets/tokens

export const PersonalAccessToken = Schema.String.pipe(
  Schema.brand("PersonalAccessToken")
);
export type PersonalAccessToken =
  typeof PersonalAccessToken.Type;

export const BearerToken = Schema.String.pipe(
  Schema.brand("BearerToken")
);
export type BearerToken = typeof BearerToken.Type;

export const ServiceAccountToken = Schema.String.pipe(
  Schema.brand("ServiceAccountToken")
);
export type ServiceAccountToken =
  typeof ServiceAccountToken.Type;

export const ApiKey = Schema.String.pipe(
  Schema.brand("ApiKey")
);
export type ApiKey = typeof ApiKey.Type;
